import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IOrder50453 } from "../../../common/types";
import { fetchOrder50453FromFirestore } from "../../../firestore/firestoreService";
import { useFirestoreCollection } from "../../../hooks/useFirestoreCollection";
import { OrderListMole } from "../../molecules";
import { orderTypes } from "../../../enums";
import { LocationDashboardWrapper } from "./Home.style";

const startOfDay = new Date();
startOfDay.setHours(0, 0, 0, 0);
export const ProductionDashboard: React.FC = () => {
  const [orders, setOrders] = React.useState<IOrder50453[]>([]);
  const { myProfile } = useSelector((state: any) => state.myProfile);
  const history = useNavigate();
  const dispatch = useDispatch();
  useFirestoreCollection({
    query: () =>
      fetchOrder50453FromFirestore([
        {
          type: "filter",
          name: "productionLineId",
          opr: "==",
          value: myProfile?.locationId,
        },
        {
          type: "filter",
          name: "status",
          opr: "==",
          value: orderTypes.PENDING.value,
        },
      ]),
    data: setOrders,
    local: true,
    deps: [dispatch, myProfile?.locationId],
  });
  const handelEditOrder = (id: string, productionLineId: string) => () => {
    history(`/production-location/${productionLineId}/order/${id}`);
  };
  return (
    <LocationDashboardWrapper>
      <div className="input-form-description text-center">Today Orders</div>
      <OrderListMole
        data={orders}
        showPagination={false}
        showLocation
        showProduction={false}
        showDeleteBtn={false}
        editOrder={handelEditOrder}
      />
    </LocationDashboardWrapper>
  );
};
